import merchant from './merchant';
import error from './error';
import member from './member';
import otherPay from './otherPay';
import paymentMethod from './paymentMethod';
import tag from './tag';
import token from './token';
import type from './type';

export default {
  merchant,
  error,
  member,
  otherPay,
  paymentMethod,
  tag,
  token,
  type,
};
